"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RawDraftContentBlockBuilder_1 = require("./RawDraftContentBlockBuilder");
var RawDraftContentBuilder = /** @class */ (function () {
    function RawDraftContentBuilder() {
        this.raw = {
            blocks: [],
            entityMap: {},
        };
    }
    RawDraftContentBuilder.prototype.withText = function (text) {
        var textBlock = new RawDraftContentBlockBuilder_1.RawDraftContentBlockBuilder().withText(text).build();
        this.raw.blocks.push(textBlock);
        return this;
    };
    RawDraftContentBuilder.prototype.build = function () {
        return this.raw;
    };
    return RawDraftContentBuilder;
}());
exports.RawDraftContentBuilder = RawDraftContentBuilder;
//# sourceMappingURL=RawDraftContentBuilder.js.map